/* eslint-disable max-len */
const urlNewLineCode = '%0D%0A%0D%0A';
export const InvitationEmailContent = {
  subject: 'Abdoo: Your Manager requests you sign up',
  body: `Hi,
${urlNewLineCode}
I would like you to sign up to Abdoo - a holiday management tracking app -  that you can request your holidays through going forward.
${urlNewLineCode}
Please follow the link: https://app.abdoo.co.uk
${urlNewLineCode}
To ensure that I receive emails with your holiday requests, on sign up it will prompt you to input my email address - please use my work email address in the field.
${urlNewLineCode}
Kind regards,
${urlNewLineCode}
Your manager (via the Abdoo Team)`,
};
/* eslint-enable max-len */
